import axios from "axios";

export const URL = axios.create({
  baseURL: "https://feelfreebe.onrender.com/",
  // baseURL: "http://localhost:4000/",
});
